import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ZoneOption } from "../../../../pending-confirmation/domain/entities/pending-confirmation";
import { type UndeliveredDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

/** The whole geo catalogue, inactive coverage included: a customer may correct
 *  his address to a municipio the operation does not serve yet, and the agent
 *  still has to be able to record it (DMS-15). */
export const listGeoCatalog = createAsyncThunk<
  ZoneOption[],
  void,
  { dispatch: UndeliveredDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_GEO_CATALOG, async (_void, { extra }) => {
  return await extra.contactCenterRepo.listGeoCatalog();
});
